export default __webpack_public_path__ + "assets/images/0a7548d1bb6a74d4736aae59fb8956ff.png";